import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../reducers/reducer";
import CustomersView from "../../views/DashboardView/SustainabilityView/CustomersView";
import { setShowModalDownloadReport } from "../../reducers/modals";
import {
  setSelectedCustomer,
  getCustomerPDFFiles,
  clearErrorfromLastcall,
} from "../../reducers/sustainability/customer";
import { setSelectedYear } from "../../reducers/exciseDuty/taxPeriods";

interface Props {
  modal_show_download_report: boolean;
  setShowModalDownloadReport: any;
  selected_customer: any;
  setSelectedCustomer: any;
  setSelectedYear: any;
  isFetching: boolean;
  getCustomerPDFFiles: any;
  CustomerPDFdata: any;
  taxPeriods: any;
  selectedYear: any;
  clearErrorfromLastcall: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      modal_show_download_report: state.modals.show_download_report,
      selected_customer: state.sustainability.customer.selected_customer,
      isFetching: state.sustainability.customer.report.isFetching,
      CustomerPDFdata: state.sustainability.customer.report,
      taxPeriods: state.exciseDuty.taxPeriods.data,
      selectedYear: state.exciseDuty.taxPeriods.selectedYear,
    }),
    (dispatch: any) => ({
      dispatch,
      setShowModalDownloadReport: (show: boolean) =>
        dispatch(setShowModalDownloadReport(show)),
      setSelectedCustomer: (customer: any) =>
        dispatch(setSelectedCustomer(customer)),
      setSelectedYear: (year: number) => dispatch(setSelectedYear(year)),
      getCustomerPDFFiles: (id: number, data: any) =>
        dispatch(getCustomerPDFFiles(id, data)),
      clearErrorfromLastcall: () => dispatch(clearErrorfromLastcall()),
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {},
  })
)(CustomersView);
